var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28965 3.23214C7.38261 3.14068 7.49321 3.06808 7.61506 3.01854C7.73691 2.96899 7.86761 2.94349 7.99961 2.94349C8.13162 2.94349 8.26231 2.96899 8.38417 3.01854C8.50602 3.06808 8.61661 3.14068 8.70957 3.23214L13.2893 7.71134C13.3823 7.80281 13.4929 7.87541 13.6147 7.92495C13.7366 7.97449 13.8673 8 13.9993 8C14.1313 8 14.262 7.97449 14.3838 7.92495C14.5057 7.87541 14.6163 7.80281 14.7092 7.71134C14.8955 7.5285 15 7.28117 15 7.02336C15 6.76555 14.8955 6.51822 14.7092 6.33538L10.1195 1.85618C9.55702 1.30794 8.79457 1 7.99961 1C7.20466 1 6.4422 1.30794 5.87973 1.85618L1.29 6.33538C1.10527 6.51714 1.00112 6.76247 1.00002 7.01848C0.999255 7.14691 1.02448 7.27422 1.07424 7.39312C1.124 7.51202 1.19733 7.62016 1.29 7.71134C1.38296 7.80281 1.49355 7.87541 1.6154 7.92495C1.73726 7.97449 1.86795 8 1.99996 8C2.13196 8 2.26266 7.97449 2.38451 7.92495C2.50637 7.87541 2.61696 7.80281 2.70992 7.71134L7.28965 3.23214Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.f3fcbc662f41f9e9a8fd832f9e5dcedf.svg";
export { ForwardRef as ReactComponent };